import {MetaTagDefinitionData} from "../meta-tag/meta-tag.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PreparationModifierEntityModel extends EntityModel<MetaTagDefinitionData> {

    constructor(injector: Injector) {
        super(injector, MetaTagDefinitionData);
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "preparation-modifier";
    }

    protected override onNewEntity(entityData: MetaTagDefinitionData): void {
        super.onNewEntity(entityData);
    }
}
